import React, { useCallback, useState, useMemo } from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import {
  Estimatebox,
  Rightrow1,
  Titles,
  EstimateIcon,
  TaskModal,
  Input,
  Lable,
  Inputlable,
  Buttons,
  Text
} from './styles';
import Button from '../../button';
import dayjs from 'dayjs';
import { floatToHHMM, getFloatTimeValue, getRawComment, isEmpty } from '../../../helpers/common';
import { isString } from 'lodash';
import TimePickerModal from '../../timePicker';
import Dropdown from '../../Dropdown/MainDropdown';
import { TaskModel } from '../../../mobx/models/task';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { COMMENT_TYPE } from '../../../global/constants';
import { nanoid } from 'nanoid';
import { RawUpdateCommentInterface } from '../../../interfaces/TaskInterface';
import { updateTaskDetails } from '../../../services/taskServices';
import { useDispatch } from 'react-redux';
import { createNewComment } from '../../../services/taskServices';
import { TASK_ANALYTICS } from '../../../global/analyticsConstants';
import { trackAnalyticActivity } from '../../../services/analyticsService';

interface Props {
  isCreateTask?: boolean;
  taskData?: TaskModel;
  isTaskDetails?: boolean;
}

const EstimateDropdownV2: React.FC<Props> = (props) => {
  // Props declaration
  const { isTaskDetails = false, taskData, isCreateTask = false } = props;

  //Mobx store variables
  const { taskStore, currentUser } = rootStore;
  const { createTaskInput } = taskStore;

  //State
  const [selectedTime, setSelectedTime] = useState(floatToHHMM(createTaskInput?.estimate || 0) || '00:00');

  /**
   * Handles time picker value changes
   * @param value - Selected time value
   */
  const handleTimeChange = (value: any) => {
    setSelectedTime(value);
  };

  //Other variables
  const dispatch = useDispatch();

  /**
   * Handles setting the estimate time for a task
   * Creates appropriate comments and updates task details
   * @param time - Selected time in HH:MM format
   */
  const onclickSet = useCallback(
    async (time: string) => {
      if (isCreateTask) {
        createTaskInput.setEstimate(getFloatTimeValue(time));
      } else {
        if (!currentUser) return;
        taskData?.setEstimate(getFloatTimeValue(time));
        const newComment: RawUpdateCommentInterface = {
          id: nanoid(),
          type: COMMENT_TYPE.ESTIMATE_TIME,
          estimateTime: getFloatTimeValue(time)
        };
        const updatedComment = getRawComment(newComment, currentUser);
        taskData?.upsertComment(updatedComment);
        const payloadTask = { estimateTime: getFloatTimeValue(time || ''), projectId: taskData?.projectId };
        const result = await dispatch(updateTaskDetails(taskData?.id, payloadTask));
        const commentResult = await dispatch(
          createNewComment(taskData?.id, {
            Type: COMMENT_TYPE.ESTIMATE_TIME,
            EstimateTime: getFloatTimeValue(time || '')
          })
        );
        if (result && commentResult) {
          trackAnalyticActivity(TASK_ANALYTICS.ESTIMATION_SET);
        }
      }
      // setIsEstimateDropdownOpen(false);
    },
    [isCreateTask, createTaskInput, currentUser, taskData, dispatch]
  );

  /**
   * Prevents event propagation when clicking input
   */
  const handleInputClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  //   useEffect(() => {
  //     if (
  //       !isEmpty(taskData?.estimate) &&
  //       !isString(taskData?.estimate) &&
  //       taskData?.estimate !== '00:00' &&
  //       taskData?.estimate !== 0
  //     ) {
  //       setSelectedTime(floatToHHMM(taskData?.estimate));
  //     }
  //   }, [taskData?.estimate, setSelectedTime]);

  // Renders the task details view of the estimate dropdown
  const taskDetailsDropdown = useMemo(() => {
    return (
      <>
        <SVGIcon name='Estimate-icon' width='16' height='16' viewBox='0 0 16 16' fill='none' className='time-icon' />
        <Titles isTaskDetails={isTaskDetails}>
          {!isEmpty(taskData?.estimate) && isString(taskData?.estimate) && taskData?.estimate !== '00:00'
            ? taskData?.estimate
            : !isEmpty(taskData?.estimate) &&
              !isString(taskData?.estimate) &&
              floatToHHMM(taskData?.estimate || 0) !== '00:00' &&
              taskData?.estimate !== 0
            ? floatToHHMM(taskData?.estimate || 0)
            : 'Set Time'}
        </Titles>
      </>
    );
  }, [isTaskDetails, taskData?.estimate]);

  // Renders the create task view of the estimate dropdown
  const createTaskDropdown = useMemo(() => {
    return (
      <>
        <EstimateIcon>
          <TaskModal changeIconColor={!isTaskDetails && !isEmpty(createTaskInput?.estimate)}>
            <SVGIcon
              name='Estimate-icon'
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
              className='time-icon'
            />
          </TaskModal>
        </EstimateIcon>
        {!isEmpty(createTaskInput?.estimate) &&
        createTaskInput?.estimate !== 0 &&
        floatToHHMM(createTaskInput?.estimate || 0) !== '00:00' ? (
          <Titles isTaskDetails={isTaskDetails}>
            {isString(createTaskInput?.estimate)
              ? createTaskInput?.estimate
              : floatToHHMM(createTaskInput?.estimate || 0)}
          </Titles>
        ) : (
          <Text isCreateTask={isCreateTask}>Estimate</Text>
        )}
      </>
    );
  }, [isCreateTask, isTaskDetails, createTaskInput?.estimate]);

  return (
    <>
      <Dropdown
        isMinWidth={198}
        isRemoveMaxHeight={true}
        content={
          <Rightrow1 isCreateTask={isCreateTask} isTaskDetails={isTaskDetails}>
            {isTaskDetails ? taskDetailsDropdown : createTaskDropdown}
          </Rightrow1>
        }
        trigger='click'
        modalTitle='Estimation'>
        <Estimatebox>
          <Inputlable>
            <Lable>Duration (HH:MM)</Lable>
            <Input onClick={handleInputClick}>
              <TimePickerModal
                value={dayjs(selectedTime, 'HH:mm')}
                onSelect={(value) => handleTimeChange(value.format('HH:mm'))}
              />
            </Input>
          </Inputlable>
          <Buttons>
            <Button title='Set' onClick={() => onclickSet(selectedTime)} modelBtn={true} />
            <Button title='Cancel' secondary modelBtn={true} />
          </Buttons>
        </Estimatebox>
      </Dropdown>
    </>
  );
};

export default observer(EstimateDropdownV2);
